import { useCallback } from 'react'
import { RectangularInputPrice } from '../../../../../../../../forms/Input/InputPrice'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { DisplayPriceGettingParams } from '../../../../../../../../baseComponents/Displays/DisplayPrice'
import { TotalPaymentsTPV } from '../../types'
import { roundNumberAndDecimals } from '@teinor/erp/prices'
import { totalCalculateParams } from '@teinor/erp/prices/quote/calculate'

interface ChangeMoneyComponentTPVProps extends ChangeMoneyComponentTPVLogicProps {
    myCurrencyId: string
    myTotalPayments: TotalPaymentsTPV
    quantity: number
}

const ChangeMoneyComponentTPV: React.FC<ChangeMoneyComponentTPVProps> = ({ myCurrencyId, myTotalPayments, quantity, setMyTotalPayments, PaymentTypeId }) => {
    const { handleChange } = useChangeMoneyComponentTPVLogic({ setMyTotalPayments, PaymentTypeId })
    const myQuantity = myTotalPayments.changeDict[PaymentTypeId]?.customerMoney || myTotalPayments.changeDict[PaymentTypeId]?.customerMoney === 0 ? myTotalPayments.changeDict[PaymentTypeId]?.customerMoney : quantity
    return (
        <div className='flex flex-auto justify-end'>
            <RectangularInputPrice label={''} CurrencyId={myCurrencyId} onChange={(value) => handleChange(value, quantity)} value={myQuantity || 0} className='justify-end flex w-150' name='customerMoney'/>
            <div className='change_money_component_box pl-25 h-33'>
                <ChangeBox {...{ myTotalPayments, PaymentTypeId, CurrencyId: myCurrencyId }} />
            </div>
        </div>
    )
}

interface ChangeMoneyComponentTPVLogicProps {
    setMyTotalPayments: React.Dispatch<React.SetStateAction<TotalPaymentsTPV>>
    PaymentTypeId: number
}

const useChangeMoneyComponentTPVLogic = ({ setMyTotalPayments, PaymentTypeId }: ChangeMoneyComponentTPVLogicProps) => {
    const handleChange = useCallback((value: string, quantity: number) => {
        setMyTotalPayments((old) => {
            const copyOld = JSON.parse(JSON.stringify(old))
            if (!copyOld.myTotalPayments.changeDict[PaymentTypeId]) {
                copyOld.myTotalPayments.changeDict[PaymentTypeId] = {}
            }
            const myValue = value || 0
            const myChange = roundNumberAndDecimals(parseFloat(String(myValue)) - parseFloat(String(quantity)), totalCalculateParams)
            copyOld.myTotalPayments.changeDict[PaymentTypeId].change = myChange
            copyOld.myTotalPayments.changeDict[PaymentTypeId].customerMoney = myValue
            if (myChange < 0) {
                if (!copyOld.myTotalPayments.errors) {
                    copyOld.myTotalPayments.errors = {}
                }
                copyOld.myTotalPayments.errors[PaymentTypeId] = true
            } else {
                if (copyOld.myTotalPayments.errors?.[PaymentTypeId]) {
                    delete copyOld.myTotalPayments.errors[PaymentTypeId]
                    if (!Object.keys(copyOld.myTotalPayments.errors).length) {
                        copyOld.myTotalPayments.errors = null
                    }
                }
            }
            return copyOld
        })
    }, [setMyTotalPayments, PaymentTypeId])
    return { handleChange }
}

interface ChangeBoxProps {
    myTotalPayments: TotalPaymentsTPV
    PaymentTypeId: number
    CurrencyId: string
}

const ChangeBox: React.FC<ChangeBoxProps> = ({ myTotalPayments, CurrencyId, PaymentTypeId }) => {
    const { t } = useTwinTranslation()
    if (!parseFloat(String(myTotalPayments.changeDict[PaymentTypeId]?.change))) {
        return null
    }
    const haveChangeMoney = myTotalPayments.changeDict[PaymentTypeId]?.change && parseFloat(String(myTotalPayments.changeDict[PaymentTypeId]?.change)) > 0
    const myText = haveChangeMoney ? t('changeMoney', 'Cambio') : t('needToPay', 'Falta')
    return (
        <div className='items-center flex py-5 px-10 medium14 box_change_tpv'>
            {myText}: <span className='ml-5'><DisplayPriceGettingParams CurrencyId={CurrencyId} value={Math.abs(myTotalPayments.changeDict[PaymentTypeId]?.change || 0)} with_vat={false} /></span>
        </div>
    )
}

export default ChangeMoneyComponentTPV